import { LucideIcon } from "lucide-react";
import Link from "next/link";
import { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface NavigationItemProps {
  title: string;
  url: string;
  icon: LucideIcon;
  testId: string;
  className?: string;
  target?: string;
  rel?: string;
  children?: ReactNode;
}

export function NavigationItem({
  title,
  url,
  icon: Icon,
  testId,
  className,
  target,
  rel,
  children,
}: NavigationItemProps) {
  return (
    <Link
      href={url}
      data-test={testId}
      title={title}
      className={cn("relative", className)}
      target={target}
      rel={rel}
    >
      <div className="relative flex flex-col items-center">
        <Icon className="h-7 w-7 mb-1" aria-hidden="true" />
        <span className="text-xs font-medium">{title}</span>
        {children}
      </div>
    </Link>
  );
}
